export enum EnvLocalStorageKeys {
    ThemePreferredColorScheme = 'theme.preferredColorScheme',
    UserRefreshToken = 'user.refreshToken',
    UserLocalStorage = 'user.localStorage',
    MobileAppCookiesPolicyAccepted = 'app.cookiesPolicyAccepted',
}